import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, MenuIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from '../ButtonLink';
import { ServicesMenu } from './ServicesMenu';
import { MobileMenu } from './MobileMenu';
import { useSiteHeader } from './useSiteHeader';
import { primaryNavLinks } from '../../data/navigation';
import { contact, images, urls } from '../../data/site';
export function SiteHeader() {
  const h = useSiteHeader();
  return <header className="sticky top-0 z-40 border-b border-line bg-paper" data-id="element-448" data-mp="luyjdwgs19g1">
      <div className="mx-auto flex h-[72px] max-w-[1320px] items-center justify-between gap-3 px-5 sm:px-8 lg:h-20 lg:px-12 xl:gap-6" data-id="element-449" data-mp="lx1hl3s328vu">
        <a href="/#top" className="shrink-0" aria-label="Motor City Truck Collision, home" data-id="element-450" data-mp="uw6e64k33s5d">
          <img src={images.logo} alt="Motor City Truck Collision" className="h-10 w-auto max-w-[190px] object-contain lg:h-12 lg:max-w-[240px]" data-id="element-451" data-mp="2sm68y7bxfaop" />
        </a>

        <nav aria-label="Primary" className="hidden lg:block" data-id="element-452" data-mp="39k5n8wuhsqnm">
          <ul className="flex items-center gap-1 xl:gap-3" data-id="element-453" data-mp="39lqk4t4a4lon">
            <li ref={h.servicesWrapRef} className="relative" onBlur={h.handleServicesBlur} data-id="element-454" data-mp="34sfa6j467osi">
              <button ref={h.servicesButtonRef} type="button" aria-expanded={h.servicesOpen} aria-controls="services-menu" onClick={h.toggleServices} className={`inline-flex h-11 items-center gap-1.5 px-2 text-[15px] font-medium transition-colors duration-150 ease-out hover:text-brand-deep xl:px-3 ${h.servicesOpen ? 'text-brand-deep' : 'text-ink'}`} data-id="element-455" data-mp="2zuvvji3k9a01">
                Services
                <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 transition-transform duration-200 ease-out ${h.servicesOpen ? 'rotate-180' : ''}`} data-id="element-456" data-mp="3dl8zl9dc04k3" />
              </button>
              <AnimatePresence data-id="element-457" data-mp="u7698txdza0z">
                {h.servicesOpen && <ServicesMenu id="services-menu" onNavigate={h.closeServices} data-id="element-458" data-mp="u7eo2rd2kpet" />}
              </AnimatePresence>
            </li>
            {primaryNavLinks.map(link => <li key={link.href} data-id="element-459" data-mp="k9igg9jccclg">
                <a href={link.href} className="inline-flex h-11 items-center px-2 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:text-brand-deep xl:px-3" data-id="element-460" data-mp="k8h481ql9k25">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-461" data-mp="1ir5j3jpge4y">
          <ButtonLink href={urls.quote} className="hidden h-11 px-5 text-[17px] sm:inline-flex md:h-11 md:px-5" data-id="element-462" data-mp="1g4pefir0qb4">
            Request a Quote
          </ButtonLink>
          <a href={contact.phoneHref} aria-label={`Call ${contact.phoneDisplay}`} className="inline-flex h-11 w-11 items-center justify-center border border-line text-ink lg:hidden" data-id="element-463" data-mp="3nqh3msi2wh45">
            <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-464" data-mp="3930jgavrpqm9" />
          </a>
          <button ref={h.mobileButtonRef} type="button" aria-expanded={h.mobileOpen} aria-controls="mobile-menu" aria-label="Open menu" onClick={h.openMobile} className="inline-flex h-11 w-11 items-center justify-center bg-ink text-paper lg:hidden" data-id="element-465" data-mp="352glj53deiz2">
            <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-466" data-mp="3nzznxpvbp3ci" />
          </button>
        </div>
      </div>

      <MobileMenu open={h.mobileOpen} onClose={h.closeMobile} onNavigate={h.navigateFromMobile} data-id="element-467" data-mp="5m0ehix5xw2q" />
    </header>;
}